import { store } from './store';
import { api_url, is_native_app } from './runtime';

function url_base64_to_uint8(base64: string): Uint8Array {
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const raw = atob(base64.replace(/-/g, '+').replace(/_/g, '/') + padding);
    const arr = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return arr;
}

async function send_subscription_to_server(sub: PushSubscription): Promise<boolean> {
    const token = store.get('auth_token');
    if (!token) {
        console.warn('[push] sem auth_token — nao enviou subscription');
        return false;
    }
    try {
        const res = await fetch(api_url('/api/push/subscribe'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(sub.toJSON()),
        });
        return res.ok;
    } catch (err) {
        console.error('[push] erro ao enviar subscription:', err);
        return false;
    }
}

export async function init_push(vapid_public_key: string): Promise<void> {
    if (is_native_app()) {
        console.warn('[push] app nativo deve registrar token FCM/APNs; Web Push fica restrito ao PWA');
        return;
    }
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('[push] SW ou PushManager nao suportado');
        return;
    }
    if (!vapid_public_key) {
        console.warn('[push] vapid_public_key vazio');
        return;
    }
    if (Notification.permission !== 'granted') {
        return;
    }

    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: url_base64_to_uint8(vapid_public_key) as BufferSource,
        });
    }

    await send_subscription_to_server(sub);
}
